import React from 'react';
import PropType from 'prop-types';

const ModalBody = ({ children, className = '', inlineStyle = {} }) => (
    <div
        className={`tr-modal-body h-100 ${className}`}
        style={inlineStyle}
        id="tr-modal-body">
        {children}
    </div>
);

ModalBody.propTypes = {
    children: PropType.node.isRequired,
    className: PropType.string
};

export default ModalBody;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/modals/modal-body.jsx